import ApiService from "../api";

export default class ParametrosComissaoService extends ApiService {

    constructor() {
        super("/api/parametros-comissao");
    }

    buscar(tipo) {
        return this.get(`/${tipo}`);
    }

    listarTodosCargos() {
        return this.get(`/cargos`);
    }

    salvar(tipo, data) {
        return this.put(`/${tipo}`, data);
    }
}